
import './App.css';
import Footer from './component/Footer/Footer';
import Home from './component/Home/Home';
import NAV from './component/Nav/Nav';

function App() {
  return (

      <div className="App">
        <NAV /> 
        <Home/>
        <Footer />
      </div>

  );
}

export default App;